import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/data/exercises";
import { Button } from "@/components/ui/button";
import { BookOpen, LogOut } from "lucide-react";
import { FamilyRelativeView } from "@/pages/FamilySpace";

// Espace des familles d'un résident en établissement (accès par le code du soignant).
export default function ResidentNews() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (user?.role !== "family") return <Navigate to="/espaces" replace />;
  if (user.space !== "residence") return <Navigate to="/famille" replace />;
  return (
    <div className="min-h-screen bg-[#F4F0E8] font-care" data-testid="resident-news-page">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3 shrink-0">
            <img src={LOGO} alt="Passerelle" className="h-10 w-auto" />
            <span className="text-gray-300 hidden sm:inline">·</span>
            <span className="text-gray-500 text-sm font-semibold hidden sm:inline whitespace-nowrap">Nouvelles de mon proche</span>
          </div>
          <div className="flex flex-wrap items-center gap-2 sm:gap-3">
            <Button variant="outline" size="sm" onClick={() => navigate("/contes")} className="rounded-lg" data-testid="resident-stories-link">
              <BookOpen className="w-4 h-4 mr-1" /> Lire un conte à voix haute
            </Button>
            <Button variant="ghost" size="sm" onClick={async () => { await logout(); navigate("/connexion"); }} data-testid="resident-logout">
              <LogOut className="w-4 h-4 mr-1" /> Déconnexion
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <FamilyRelativeView residence />
      </main>
    </div>
  );
}
